module.exports = __webpack_public_path__ + "static/media/veneto-village-09.dcc1966e.jpg";